import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";
import { SIZES } from "theme";
import { useTranslation } from "react-i18next";

const IconHolder = ({ img, description, title, small }) => {
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      w={small ? "100%" : "262px"}
      textAlign="center"
      margin="0 auto"
    >
      <Box
        h={small ? "80px" : "118px"}
        w={small ? "80px" : "118px"}
        background="#000000"
        borderRadius="50%"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          padding="7px"
        >
          <img
            src={img}
            alt="icon"
            style={{ height: small ? "80%" : "100%", objectFit: "contain" }}
          />
        </Box>
      </Box>
      <Box
        textAlign="center"
        h="66px"
        display="flex"
        alignItems="start"
        marginTop="27px"
      >
        <Text
          fontSize={small ? SIZES.twenty : "24px"}
          fontWeight="bold"
          textColor="white"
          margin="0"
        >
          {t(title)}
        </Text>
      </Box>
    </Box>
  );
};

export default IconHolder;
